var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-dropdown',_vm._b({attrs:{"rules":_vm.rules,"options":_vm.options || [],"value":_vm.value,"placeholder":_vm.$t('fields.pref')},on:{"input":_vm.onChange}},'x-dropdown',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }